// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + {"128":"37abd01ef40d2e30f874","556":"0742507281f4d6391f32","622":"338d4b7e873f7a99a281","964":"d48cef6c742af7adf01b"}[chunkId] + ".min.js";
};